module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/stepper_down@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/stepper_down@2x.png
// module id = 660
// module chunks = 0